import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { selectActiveServiceId, selectIsPackagesAvailable } from '../../../../selectors/publishTerms';
import { PackagesTitle } from './PackagesTitle';

export const PackagesTitleContainer = () => {
  const isMobile = useIsMobileDevice();
  const selectedServiceId = useSelector(selectActiveServiceId);
  const isPackagesAvailable = useSelector(selectIsPackagesAvailable);

  if (!selectedServiceId || isMobile || !isPackagesAvailable) {
    return null;
  }

  return <PackagesTitle serviceId={selectedServiceId} />;
};
